import { css } from 'styled-components';
export var textStyles = css(["", ";color:", ";", ";"], function (_ref) {
  var margin = _ref.margin;
  return margin && "margin: ".concat(margin, ";");
}, function (_ref2) {
  var theme = _ref2.theme,
    light = _ref2.light;
  return light ? theme.colors.fontL : 'currentColor';
}, function (_ref3) {
  var textAlign = _ref3.textAlign;
  return textAlign && "text-align: ".concat(textAlign);
});